import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {isNumeric} from '../../../../../../../../../../validators/ControlValidators';

@Component({
  selector: 'shared-szerokosc',
  templateUrl: './szerokosc.component.html'
})

export class SzerokoscComponent implements OnInit {

  language = window.navigator.language

  get SZEROKOSC() { return this.formularzUszkodzenia.controls.szerokosc }

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  @Input()
  minimalnaSzerokosc!: number;

  @Input()
  maksymalnaSzerokosc!: number;

  ngOnInit(): void {
    this.formularzUszkodzenia.controls.szerokosc.setValidators([Validators.required,
      Validators.min(this.minimalnaSzerokosc), Validators.max(this.maksymalnaSzerokosc), isNumeric()]);
  }

}
